
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/samochody-ciezarowe/[marka]",
      function () {
        return require("private-next-pages/samochody-ciezarowe/[marka]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/samochody-ciezarowe/[marka]"])
      });
    }
  